/**
 * Created by zad on 17/12/6.
 */
const fireFoxReg = /firefox/i;
const chromeReg = /chrome/i;
const safariReg = /safari/i;
const androidReg = /android/i;
const iPhoneReg = /iPhone/i;
const iPadReg = /iPad/i;

export function isFirefox() {
  const { navigator: { userAgent } } = window;
  return fireFoxReg.test(userAgent);
}

export function isChrome() {
  const { navigator: { userAgent } } = window;
  return chromeReg.test(userAgent);
}

export function isSafari() {
  const { navigator: { userAgent } } = window;
  return safariReg.test(userAgent) && !isChrome();
}

export function isAndroid() {
  const { navigator: { userAgent } } = window;
  return androidReg.test(userAgent);
}

export function isiPhone() {
  const { navigator: { userAgent } } = window;
  return iPhoneReg.test(userAgent);
}


export function isiPad() {
  const { navigator: { userAgent } } = window;
  return iPadReg.test(userAgent);
}

export function isPC() {
  return !(isAndroid() || isiPhone() || isiPad());
}



// WEBPACK FOOTER //
// ./src/utils/browserDetector.js